import React, { useEffect, useState } from 'react';
import './App.css';

function Livrare() {
    useEffect(() => { window.scrollTo(0, 0); document.title = 'Livrare | SPCheapCars'; }, []);

    const primaryOrange = "#ff8e18";
    const trustNavy = "#1c2e4a";

    const [isMobile, setIsMobile] = useState(window.innerWidth < 992);
    useEffect(() => {
        const onResize = () => setIsMobile(window.innerWidth < 992);
        window.addEventListener('resize', onResize);
        return () => window.removeEventListener('resize', onResize);
    }, []);

    const glassDark = {
        background: 'rgba(255,255,255,0.07)',
        backdropFilter: 'blur(14px)',
        WebkitBackdropFilter: 'blur(14px)',
        border: '1px solid rgba(255,255,255,0.13)',
        borderRadius: '16px',
    };

    const heroTexture = [
        'repeating-linear-gradient(125deg, transparent 0px, transparent 16px, rgba(255,255,255,0.06) 16px, rgba(255,255,255,0.06) 17px)',
        'repeating-linear-gradient(35deg, transparent 0px, transparent 32px, rgba(255,142,24,0.045) 32px, rgba(255,142,24,0.045) 33px)',
        'radial-gradient(ellipse at 70% 0%, rgba(255,142,24,0.1) 0%, transparent 50%)',
        'linear-gradient(180deg, rgba(28,46,74,0) 0%, rgba(15,26,43,0.5) 100%)'
    ].join(', ');

    const steps = [
        { num: '1', title: 'Contactează-ne',     desc: 'Sună sau scrie pe WhatsApp.' },
        { num: '2', title: 'Verifici și Semnezi', desc: 'Personal în showroom sau prin inspecție video live.' },
        { num: '3', title: 'Primești Mașina',    desc: 'Livrare la adresă sau ridicare gratuită din Timișoara.' }
    ];

    const deliveryModes = [
        { icon: 'bi-building', title: 'Ridicare din Showroom — Gratuit', desc: 'Vino la noi în Timișoara și pleci direct cu mașina, fără niciun cost suplimentar.' },
        { icon: 'bi-truck',    title: 'Livrare Oriunde în România',      desc: 'Aducem mașina la adresa ta, cu transport asigurat pe toată durata drumului.' }
    ];

    const assurances = [
        { icon: 'bi-shield-check',      title: 'Inspecție Finală',              desc: 'Verificare completă înainte de predare.' },
        { icon: 'bi-file-earmark-text', title: 'Documente Pregătite din Timp',  desc: 'Actele sunt gata în avans — predarea durează minute.' },
        { icon: 'bi-camera-video',      title: 'Inspecție Video Live',          desc: 'Îți arătăm mașina în detaliu, live, înainte să te decizi.' }
    ];

    const docs = [
        { icon: 'bi-person-badge', text: 'Act de identitate (CI sau Pașaport)' },
        { icon: 'bi-car-front',    text: 'Permis de conducere valabil' },
        { icon: 'bi-cash-stack',   text: 'Dovada plății sau contract de finanțare' },
        { icon: 'bi-building',     text: 'CUI firmă (doar persoane juridice)' }
    ];

    return (
        <div style={{ background: '#f0f4f9', minHeight: '100vh' }}>

            {/* ══════════════════════════════════════════════════════════════
                SECTION 1 — HERO
            ══════════════════════════════════════════════════════════════ */}
            <div className="position-relative page-hero" style={{ background: trustNavy, paddingTop: isMobile ? '32px' : '120px', paddingBottom: isMobile ? '48px' : '80px' }}>
                <div className="position-absolute top-0 start-0 w-100 h-100" style={{ background: heroTexture }}></div>
                <div className="container text-center text-white position-relative">
                    <div style={{
                        display: 'inline-block', background: `${primaryOrange}22`,
                        border: `1px solid ${primaryOrange}55`, color: primaryOrange,
                        fontSize: '0.65rem', fontWeight: '700', textTransform: 'uppercase',
                        letterSpacing: '3px', padding: '5px 16px', borderRadius: '40px', marginBottom: '18px'
                    }}>LIVRARE NAȚIONALĂ</div>
                    <h1 style={{
                        fontWeight: '900', letterSpacing: isMobile ? '1px' : '3px',
                        fontSize: isMobile ? '2rem' : 'clamp(2.2rem, 5vw, 3.5rem)',
                        textTransform: 'uppercase', color: '#ffffff', lineHeight: '1.15', marginBottom: '12px'
                    }}>Livrare</h1>
                    <div style={{ width: '50px', height: '3px', background: primaryOrange, margin: '0 auto 16px', borderRadius: '2px' }}></div>
                    <p style={{ opacity: 0.7, maxWidth: '460px', margin: '0 auto 32px', fontSize: isMobile ? '0.95rem' : '1.05rem', lineHeight: '1.7' }}>
                        Ridicare gratuită sau livrare la domiciliu — oriunde în România.
                    </p>

                    {/* Glass stat pills */}
                    <div className="d-flex flex-wrap justify-content-center" style={{ gap: '12px' }}>
                        {[
                            { big: 'Gratuit', label: 'Ridicare Showroom', icon: 'bi-building' },
                            { big: 'Național', label: 'Livrare România', icon: 'bi-truck' },
                            { big: 'Live', label: 'Inspecție Video', icon: 'bi-camera-video' }
                        ].map((s, i) => (
                            <div key={i} style={{ ...glassDark, padding: isMobile ? '12px 20px' : '14px 28px', display: 'flex', alignItems: 'center', gap: '12px', flex: '0 1 auto', minWidth: isMobile ? 'calc(45% - 6px)' : 'auto' }}>
                                <i className={`bi ${s.icon}`} style={{ color: primaryOrange, fontSize: '1.1rem' }}></i>
                                <div style={{ textAlign: 'left' }}>
                                    <div style={{ color: '#fff', fontWeight: '700', fontSize: isMobile ? '1rem' : '1.15rem', lineHeight: 1 }}>{s.big}</div>
                                    <div style={{ color: 'rgba(255,255,255,0.62)', fontSize: '0.65rem', textTransform: 'uppercase', letterSpacing: '0.8px', marginTop: '2px' }}>{s.label}</div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {/* ══════════════════════════════════════════════════════════════
                SECTION 2 — CUM PRIMEȘTI MAȘINA (light)
            ══════════════════════════════════════════════════════════════ */}
            <div className="ip-section">
                <div className="container">
                    <div className="ip-header text-center">
                        <span className="ip-eyebrow">FĂRĂ BĂTĂI DE CAP</span>
                        <h2 className="ip-title">Cum Primești Mașina</h2>
                    </div>

                    <div className="row g-3">
                        {deliveryModes.map((item, i) => (
                            <div className="col-12 col-md-6" key={i}>
                                <div className="ip-card">
                                    <div className="ip-tile">
                                        <i className={`bi ${item.icon}`}></i>
                                    </div>
                                    <div>
                                        <h6 className="ip-card-title">{item.title}</h6>
                                        <p className="ip-card-text">{item.desc}</p>
                                    </div>
                                </div>
                            </div>
                        ))}
                        {assurances.map((item, i) => (
                            <div className="col-12 col-md-4" key={`a-${i}`}>
                                <div className="ip-card">
                                    <div className="ip-tile ip-tile--soft ip-tile--sm">
                                        <i className={`bi ${item.icon}`}></i>
                                    </div>
                                    <div>
                                        <h6 className="ip-card-title">{item.title}</h6>
                                        <p className="ip-card-text">{item.desc}</p>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {/* ══════════════════════════════════════════════════════════════
                SECTION 3 — PAȘI + DOCUMENTE + CTA (dark)
            ══════════════════════════════════════════════════════════════ */}
            <div className="ip-section ip-section--dark">
                <div className="container position-relative">

                    {/* ── Steps ── */}
                    <div className="row align-items-center g-4 g-lg-5">
                        <div className="col-12 col-lg-5">
                            <h2 className="ip-title ip-title--light">3 Pași Simpli</h2>
                            <p className="ip-lead ip-lead--light">De la primul contact până la cheia mașinii.</p>
                        </div>
                        <div className="col-12 col-lg-7">
                            <div className="ip-card-dark">
                                {steps.map((step, i) => (
                                    <div key={i} className="ip-list-item align-items-center">
                                        <div className="ip-num">{step.num}</div>
                                        <div>
                                            <div className="ip-item-title">{step.title}</div>
                                            <div className="ip-item-sub">{step.desc}</div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>

                    <div className="ip-divider"></div>

                    {/* ── Documents ── */}
                    <div className="row g-4 align-items-start">
                        <div className="col-12 col-lg-5">
                            <h3 className="ip-title ip-title--light" style={{ fontSize: '1.3rem' }}>Documente Necesare</h3>
                            <p className="ip-lead ip-lead--light">Pregătește aceste documente pentru ridicare.</p>
                        </div>
                        <div className="col-12 col-lg-7">
                            <div className="ip-card-dark">
                                {docs.map((d, i) => (
                                    <div key={i} className="ip-list-item align-items-center">
                                        <div className="ip-tile ip-tile--soft ip-tile--sm">
                                            <i className={`bi ${d.icon}`}></i>
                                        </div>
                                        <span style={{ color: 'rgba(255,255,255,0.75)', fontSize: '0.88rem', fontWeight: '500' }}>{d.text}</span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>

                    <div className="ip-divider"></div>

                    {/* ── CTA ── */}
                    <div className="ip-cta-row">
                        <a href="tel:0741811511" className="ip-btn ip-btn--glass">
                            <i className="bi bi-telephone-fill"></i>
                            0741 811 511
                        </a>
                        <a href={'https://wa.me/40741811511?text=' + encodeURIComponent('Salut! Aș dori detalii despre livrarea unei mașini.')}
                            target="_blank" rel="noreferrer" className="ip-btn ip-btn--wa">
                            <i className="bi bi-whatsapp"></i>
                            WhatsApp
                        </a>
                    </div>

                </div>
            </div>
        </div>
    );
}

export default Livrare;
